import src from "IMAGE";
export default { src, width: 0, height: 0, blurWidth: 0, blurHeight: 0};
